module.exports = __webpack_public_path__ + "icons.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/dist/themes/default/assets/fonts/icons.woff2
// module id = ../../../../../src/assets/dist/themes/default/assets/fonts/icons.woff2
// module chunks = styles